import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

import { onlyNumber, RECAPTCHA_SITE_KEY } from "../../constants/app-constants";
import { useLocation } from "react-router-dom";
import { requestCallback } from "../../actions/cms-api-handlers";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from 'react-toastify';
import {  useSelector } from 'react-redux';
import { leadSquaredStatus } from "../../actions/post-call";
const Iprops = {
  position: true || false,
};
const RequestCallback = ({ position, SourceCampaign }) => {

  const [modal, setModal] = useState(false);
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [query, setQuery] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, showMessage] = useState(false);
  const location = useLocation();
	const selectedUser = useSelector((state) => state.selectedUser.value);
  const Defaultlocation = useSelector((state) => state.location.value);
  const handleShow = () => {
    setModal(true);
  };
  const handleClose = () => {
    setModal(false);
  };
  useEffect(() => {
		if (selectedUser) {
			setFullName(selectedUser.full_name);
      setMobile(selectedUser.mobile_number )
		} 
	}, [selectedUser])
	const [captchaValue, setCaptchaValue] = useState(null);
	const _reCaptchaRef = React.createRef();

	const CaptchaChangeHandler = (value) => {
		setCaptchaValue(value);
	};


  const handleSubmit = async () => {
  
    if (!fullName || !mobile || !query  || !captchaValue  ) {
      setErrors({
        ...errors,
        fullName: !fullName ? "Full Name is required!" : "",
        mobile: !mobile
          ? "Please enter Mobile No."
        
          : "",
        query: !query ? "Please write your Query" : "",
   
        });
        if (captchaValue == null) {
          showToast("Capcha is required");
          return false;
           }

       } 
       
       else {

      setErrors({});
      let payload1 = [      
        { "Attribute": "FirstName", "Value": fullName },
        { "Attribute": "Mobile", "Value": mobile },
        { "Attribute": "mx_City", "Value":   Defaultlocation=== null ? "undefined":  selectedUser === null ? Defaultlocation?.city:selectedUser?.city_name},
        { "Attribute": "SourceCampaign", "Value": SourceCampaign },
        { "Attribute": "SourceMedium", "Value": "Website" },
      ];   
      let payload = {
        type:location.pathname ==='/care-package-categories' ? "1":"2",
        name: fullName,
        message: query,
        phone: mobile,
      }; 
         setLoading(true);
      leadSquaredStatus(payload1).then(function (response) {
        if(response.status==200){        
          requestCallback(payload)
          .then((response) => {     
            if(response.status==200){   
            setLoading(false);
            showMessage(true);
            }
            else{
              showToast(response.data.message) 
              setLoading(false);
            }
          })
          .catch(() => {
            setLoading(false);
          });
        }
     
        })
 
    }
  };
  const resetModalData = () => {
    showMessage(false);
    // setFullName("");
    // setMobile("");
    setQuery("");
    setErrors({});
  };
  function showToast(str) {
		toast.error(str, {
			position: "top-right",
			autoClose: 3000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: false,
			draggable: false
		});
	}

  return (
    <React.Fragment>
      <p
        className={`fs-6 text-secondary ${
          position === true ? "callback" : ""
        } `}
      >
        Couldn’t find what you are looking for?{" "}
        <span onClick={handleShow} className="text-primary cursor-pointer">
          {" "}
          Request a Callback 
        </span>
      </p>
      <Modal
        show={modal}
        onHide={handleClose}
        size="md"
        onShow={resetModalData}
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">Request a Callback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row ">
            {!message ? (
              <>
                <div className="col-lg-6">
                  <div className="form-floating mb-4">
                    <input
                      type="text"
                      className="form-control"
                      id="fullName"
                      name="fullName"
                      placeholder="fullName"
                      value={fullName}
                      autoComplete="off"
                      onChange={(e) => {
                        let fullName = e.target.value
                        setErrors({ ...errors, fullName: !fullName ? "Full Name is required!" : "" });
                        setFullName(e.target.value);
                      }}
                    />
                    <label htmlFor="fullName">
                      Full Name <sup>*</sup>
                    </label>
                    {errors.fullName && (
                      <div style={{ color: "red" }}>{errors.fullName}</div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-floating mb-4">
                    <input
                      type="text"
                      className="form-control"
                      id="Mobile"
                      placeholder="Mobile"
                      value={mobile}
                      maxLength="10" max="10" min="10"
                      onKeyPress={(e) => onlyNumber(e)}
                      onChange={(e) => {
                        let mobile = e.target.value
                        setErrors({ ...errors, mobile: !mobile
                          ? "Please enter mobile number"
                        
                          : "", });

                        setMobile(e.target.value);
                      }}
                    />
                    <label htmlFor="Mobile">
                      Mobile <sup>*</sup>
                    </label>
                    {errors.mobile && (
                      <div style={{ color: "red" }}>{errors.mobile}</div>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating mb-4">
                    <textarea
                      className="form-control"
                      placeholder="Leave a comment here"
                      id=""
                      value={query}
                      onChange={(e) => {
                        let query= e.target.value
                        setErrors({ ...errors, query: !query ? "Please write your Query" : "", });

                        setQuery(e.target.value);
                      }}
                    />
                    <label htmlFor="floatingTextarea2">Query</label>
                    {errors.query && (
                      <div style={{ color: "red" }}>{errors.query}</div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                <ReCAPTCHA
												ref={_reCaptchaRef}
												sitekey={RECAPTCHA_SITE_KEY}
												onChange={CaptchaChangeHandler}
											// asyncScriptOnLoad={asyncScriptOnLoad}
											/>
						
                  </div>
                <div className="col-lg-6 align-self-end text-start text-lg-end mt-3 mt-lg-0">
                  <button
                    className="btn btn-primary rounded-1 "
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </>
            ) : (
              <div className="col-12 text-center">
                {message && (
                  <>
                    <p className="text-primary  mt-4">
                      {" "}
                      Thank you for contacting MyHealthcare. Our team shall get in touch with you soon. Have a nice day!
                    </p>
                    <button
                      className="btn btn-primary rounded-1 "
                      onClick={handleClose}
                    >
                      OK
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default RequestCallback;
